// Auth0 Google Workspace connection for staff; Universal Login routes these emails here by domain.
export const JOY_SSO_CONNECTION = 'withjoy.com';

export const isJoySsoEmail = (email?: string): boolean => !!email && email.trim().toLowerCase().endsWith('@withjoy.com');

// Auth0 subject of a Joy Google Workspace identity. Same regex as identity_service's JOY_WORKSPACE_AUTH0_ID.
// identity exposes a phantom alias with `provider: ''` (`phantom` is not in the schema), so a non-empty provider stands in for "not phantom".
export const JOY_WORKSPACE_AUTH0_ID = /^google-apps\|[^|@\s]+@withjoy\.com$/i;

export type AliasIdentity = Readonly<{ provider: string; auth0Id: string }>;

export const isJoyWorkspaceAlias = (alias: AliasIdentity): boolean => !!alias.provider && JOY_WORKSPACE_AUTH0_ID.test(alias.auth0Id);

export const findJoyWorkspaceAlias = <T extends AliasIdentity>(aliases: ReadonlyArray<T>): T | undefined => aliases.find(isJoyWorkspaceAlias);
